<template>
  <h1>Edit goodie</h1>
  <form @submit.prevent="updateGoodie">
    <div class="form-group mb-3">
      <label for="name" class="form-label">Name</label>
      <input type="text" id="name" class="form-control" v-model="name" required>
      <div v-if="nameError" class="text-danger">{{ nameError }}</div>
    </div>
    <div class="form-group mb-3">
      <label for="description" class="form-label">Description</label>
      <input type="text" id="description" class="form-control" v-model="description">
    </div>
    <div class="form-group mb-3">
      <label for="capacity" class="form-label">Capacity</label>
      <input type="number" id="capacity" class="form-control" v-model="capacity" min="0" required>
    </div>
    <div class="form-check mb-3">
      <label for="visible" class="form-check-label">Visible</label>
      <input type="checkbox" id="visible" class="form-check-input" v-model="visible">
    </div>

    <button type="submit" class="btn btn-primary me-3" :disabled="nameError !== ''">Save changes</button>
    <button type="button" class="btn btn-secondary" @click="$emit('close')">Cancel</button>
  </form>
</template>

<script>
import {onMounted, ref, watch} from "vue";
import {API_BASE_URL} from "@/config";
import {getCSRFToken} from "@/store/auth";

function debounce(fn, delay) {
  let timeoutID;
  return function (...args) {
    clearTimeout(timeoutID);
    timeoutID = setTimeout(() => fn.apply(this, args), delay);
  };
}

export default {
  props: {
    goodie: {
      type: Object,
      required: true
    },
    organisation: {
      type: Object,
      required: true
    }
  },
  emits: ['close'],

  setup(props) {
    const name = ref(props.goodie.name);
    const description = ref(props.goodie.description);
    const capacity = ref(props.goodie.capacity);
    const visible = ref(props.goodie.visible_for_user);
    const nameError = ref('');

    onMounted(() => {
      document.getElementById('name').focus();
    });

    const validateName = debounce(async (newName) => {
      if (newName !== props.goodie.name) {
        try {
          const response = await fetch(
              `${API_BASE_URL}/organisations/${props.organisation.slug}/goodie-name-is-available`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-CSRFToken': getCSRFToken()
                },
                body: JSON.stringify({
                  name: newName
                }),
                credentials: 'include'
              });
          const data = await response.json();
          nameError.value = data.message;
        } catch (err) {
          console.error('Error checking goodie name:', err);
        }
      } else {
        nameError.value = '';
      }
    }, 500);

    watch(name, (newName) => {
      validateName(newName);
    });

    return {
      name,
      description,
      capacity,
      visible,
      nameError,
    };
  },

  methods: {
    async updateGoodie() {
      try {
        const response = await fetch(
            `${API_BASE_URL}/goodies/${this.goodie.id}`, {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': getCSRFToken()
              },
              body: JSON.stringify({
                name: this.name.trim(),
                description: this.description.trim(),
                capacity: this.capacity,
                visible_for_user: this.visible,
                organisation: this.goodie.organisation,
              }),
              credentials: 'include'
            }
        );
        if (response.ok) {
          this.$emit('close');
        } else {
          console.error('Error updating goodie:', response.statusText);
        }
      } catch (error) {
        console.error('Error updating goodie:', error);
      }
    }
  }
};
</script>